import { render, staticRenderFns } from "./DestinationTripList.vue?vue&type=template&id=2f75d072"
import script from "./DestinationTripList.vue?vue&type=script&lang=ts"
export * from "./DestinationTripList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports